import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import { Root } from './css'

const Index = ({ store }) => {
  const history = useHistory();

  if (process.env.NODE_ENV !== "development") {
    history.push('/')
    return null
  }

  return (
    <Root>
      <iframe src="https://ruu3c7ydqa.dmail.ai/airdrop" />
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))